import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClientsService {

    baseUrl = `${environment.apis.base}/clients`;

    constructor(private readonly http: HttpClient) { }

    datatable(page?: number, options?: any): Observable<Object> {
		let httpParams = new HttpParams();

		if (typeof page === 'number') {
			httpParams = httpParams.append('page', page);
		}

		if ('key' in options && options.key.trim() !== '') {
			httpParams = httpParams.append('search', options.key);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

    activityList(page?: number, options?: any): Observable<Object> {
        let url = `${this.baseUrl}/${options.mac}/activity`;

        if (typeof page === 'number') {
            url += `?page=${page}`;
        }
        return this.http.get<any>(url);
    }
}
